var exports = {
  "Q": "MessagesTab.module__switchWrapper___dXFRam",
};

module.exports = exports;
